// eslint-disable-next-line
export const RECORD_TYPE = {
  UNIT: Symbol("UNIT"),
  SUBUNIT: Symbol("SUBUNIT"),
  ACTIVITY: Symbol("ACTIVITY"),
};
